import axios from "@/api/axios"

class Device {
  constructor() {
    this.numpad = true
  }
  async _init() {
    _$.vue.$on("bluetooth", () => this._checkRemoteState())
    window.setInterval(() => this._checkRemoteState(), 10000)
    return true
  }

  async properties() {
    const { macAddress, ipAddress, serial, firmwareVersion, appVersion, brand, model } = await __._api.getProperties()

    const properties = {
      mac: macAddress,
      ip: ipAddress,
      serial: serial || "000000",
      firmware: firmwareVersion || "firmwareVersion",
      software: appVersion || "software",
      manufacturer: brand.toUpperCase() || "manufacturer",
      product: model || "model",
      type: "playmoretv"
    }

    const res = Object.keys(properties).every(key => properties[key] || false)

    return res && properties
  }
  async baseUrl() {
    try {
      return JSON.parse(playmore.platform.getConfigAll("private")).url
    } catch (error) {
      return location.origin
    }
  }
  async getKeyMap() {
    return [
      // Controllers
      [21, "left"],
      [19, "up"],
      [22, "right"],
      [20, "down"],
      [23, "enter"],
      [4, "back"],
      [3, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [85, "toggle"],
      [86, "stop"],
      [90, "fw"],
      [89, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      //[92, "ch_up"],
      //[93, "ch_down"],
      [166, "ch_up"],
      [167, "ch_down"],
      [141, "tv"], //Register
      [-1, "subtitle"], //Register
      [82, "list"], //Register
      [139, "epg"],
      [-1, "switch"],
      [-1, "favorite"],

      // General
      [165, "info"],
      [-1, "settings"], //Register
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [140, "source"], //Register
      [-1, "power"],
      [-1, "home"], //Register
      [-1, "refresh"], //Register

      [183, "red"],
      [184, "green"],
      [185, "yellow"],
      [186, "blue"],

      // Numpad
      [7, "numpad", 0],
      [8, "numpad", 1],
      [9, "numpad", 2],
      [10, "numpad", 3],
      [11, "numpad", 4],
      [12, "numpad", 5],
      [13, "numpad", 6],
      [14, "numpad", 7],
      [15, "numpad", 8],
      [16, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"],
      [-1, "shahid"]
    ]
  }
  async setName(name, adb = false) {
    if (!name) return false

    if (!adb) return playmore.device.setDeviceName(name)
    return __.api.adb.send({
      device: __.device.properties.ip,
      command: "name",
      params: {
        name: name
      }
    })
  }
  async getName() {
    return playmore.device.getDeviceName()
  }

  /* Register Methods */
  async registerKeys() {
    return true
  }

  /* Volume Management */
  async volume(volume) {
    if (typeof volume !== "number") return playmore.device.volume()
    else return playmore.device.volume(volume)
  }
  async mute(value) {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return playmore.device.mute(_$.true(value))
    return playmore.device.mute()
  }
  async maxVolume() {
    _$.vue.$on("volumeChanged", event => {
      if (event.detail > __.device.maxVolume) __.device.volume(__.device.maxVolume)
    })
    return true
  }

  /* Power Management */
  async getPowerState() {
    return "on"
  }
  async powerOn() {
    return true
  }
  async standBy() {
    return true
  }
  async reboot() {
    playmore.platform.setConfig("rebootByDevice", true)
    setTimeout(() => playmore.device.reboot(), 2000)
    return true
  }
  async clearData() {
    const { manufacturer } = __.device.properties

    if (["ARGUEST"].includes(manufacturer)) {
      const promise = await _$.progress.create()

      /* Library Code */
      playmore.platform.returnToPlatform()
      await _$.sleep(1500)
      playmore.device.clearAppData()
      /* Library Code */

      _$.sleep(3000).then(() => promise.resolve())

      return promise.done
    } else {
      return __.api.adb.send({
        device: __.device.properties.ip,
        command: "clear",
        params: {
          packages: __.app.availableApps.map(item => item.key).filter(item => !item.includes("com.playroomtv.playroomstb"))
        }
      })
    }
  }

  /* Soft AP */
  async getSoftAP() {
    const { password, ssid, status } = {}

    return {
      ssid: ssid,
      password: password,
      status: _$.true(status)
    }
  }
  async enableSoftAP() {
    return true
  }
  async disableSoftAP() {
    return true
  }
  async isSoftAPEnabled() {
    return false
  }
  _checkRemoteState() {
    const oval = _$.store.getItem("remoteState"),
      oval_ = JSON.stringify(oval)

    const nval = this._getRemoteState(),
      nval_ = JSON.stringify(nval)

    if (oval_ === nval_) return

    _$.store.setItem("remoteState", nval)
    const locationNumber = __.device.get("location")

    axios()
      .post("/api/send/remoteState", { mac: __.device.properties.mac, location: locationNumber, state: nval_ })
      .catch(err => _$.error(err))

    return true
  }
  _getRemoteState() {
    try {
      const device = JSON.parse(playmore.device.getBluetoothDevices())
        .devices.filter(item => item.name === "RemoteG10")
        .pop()

      const { connected: status, batteryLevel: battery } = device

      return { status, battery }
    } catch (error) {
      return { status: false, battery: 0 }
    }
  }
}

export default Device
